export default function checkInServiceMock({ request, resolve }) {
    setTimeout(() => {
        resolve({
            succeeded: request.data.patients,
            failed: request.data.patients,
        });
    }, 3000);
}
